module.exports = __webpack_public_path__ + "static/HND_zip_codes-58386c4ebde9a37bea57f9fb3903c6cb.pdf";